"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeAddressFieldValue = sanitizeAddressFieldValue;
exports.sanitizeBasicInputFieldValue = sanitizeBasicInputFieldValue;
exports.sanitizeEmailValue = sanitizeEmailValue;
exports.sanitizePhoneLocalValue = sanitizePhoneLocalValue;
var _textUtils = require("../../textUtils");
function sanitizeEmailValue(value) {
  return (0, _textUtils.sanitizeTextValue)(value).replace(/\s+/g, '').toLowerCase();
}
function sanitizePhoneLocalValue(value) {
  return (0, _textUtils.sanitizeTextValue)(value).replace(/[^0-9()\-\s.]/g, '');
}
function sanitizeAddressFieldValue(value) {
  return (0, _textUtils.sanitizeTextValue)(value);
}
function sanitizeBasicInputFieldValue(value) {
  return (0, _textUtils.sanitizeTextValue)(value);
}